"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebCoreEvent = void 0;
const schemas_1 = require("@checkatrade/schemas");
const typebox_1 = require("@sinclair/typebox");
exports.WebCoreEvent = typebox_1.Type.Object({
    event_name: typebox_1.Type.String(),
    ts: typebox_1.Type.String(),
    ts_local: typebox_1.Type.String(),
    app_version: typebox_1.Type.String(),
    environment: typebox_1.Type.String(),
    user_id: typebox_1.Type.Optional((0, schemas_1.Nullable)(typebox_1.Type.String())),
    session: typebox_1.Type.String(),
    device_id: (0, schemas_1.Nullable)(typebox_1.Type.String()),
});
//# sourceMappingURL=web-core-event.js.map